import { Routes } from '@angular/router';
import { InviteCodeComponent } from './invite-code/invite-code.component';

export const InviteCodeRoutingModule: Routes = [
	{ path: 'invite-code', component: InviteCodeComponent },
];
